const noiseBuffer = (ctx) => {
  const buf = ctx.createBuffer(1, Math.floor(ctx.sampleRate * 0.15), ctx.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i += 1) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length) ** 3;
  return buf;
};

const env = (g, t, peak, attack, release) => {
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t + attack + release);
};

export const playLogoSound = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return () => {};
  const ctx = new Ctx();
  ctx.resume?.();
  const now = ctx.currentTime + 0.05;
  const master = ctx.createGain();
  master.gain.value = 0.55;
  master.connect(ctx.destination);

  const hum = ctx.createGain();
  hum.gain.setValueAtTime(0.0001, now);
  hum.gain.exponentialRampToValueAtTime(0.16, now + 1.4);
  hum.gain.setValueAtTime(0.16, now + 3.9);
  hum.gain.exponentialRampToValueAtTime(0.0001, now + 5.8);
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.setValueAtTime(180, now);
  lp.frequency.linearRampToValueAtTime(950, now + 3.7);
  lp.connect(hum);
  hum.connect(master);
  [[55, "sawtooth", 0.45], [110.6, "sine", 0.35], [165.4, "sine", 0.18]].forEach(([f, type, vol]) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = type;
    o.frequency.value = f;
    g.gain.value = vol;
    o.connect(g);
    g.connect(lp);
    o.start(now);
    o.stop(now + 6);
  });
  const lfo = ctx.createOscillator();
  const lfoGain = ctx.createGain();
  lfo.frequency.value = 6.5;
  lfoGain.gain.value = 110;
  lfo.connect(lfoGain);
  lfoGain.connect(lp.frequency);
  lfo.start(now);
  lfo.stop(now + 6);

  const buf = noiseBuffer(ctx);
  [0.5, 0.72, 0.94, 1.16, 2.3, 2.48].forEach((t, i) => {
    const src = ctx.createBufferSource();
    const hp = ctx.createBiquadFilter();
    const g = ctx.createGain();
    src.buffer = buf;
    hp.type = "highpass";
    hp.frequency.value = 2200 + i * 300;
    g.gain.value = i > 3 ? 0.12 : 0.2;
    src.connect(hp);
    hp.connect(g);
    g.connect(master);
    src.start(now + t);
  });

  [[1046.5, 0], [1568, 0.09], [2093, 0.18], [2637, 0.27]].forEach(([f, dt], i) => {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    const t = now + 3.9 + dt;
    o.type = "sine";
    o.frequency.value = f;
    env(g, t, i === 3 ? 0.08 : 0.2, 0.015, 2.4);
    o.connect(g);
    g.connect(master);
    o.start(t);
    o.stop(t + 2.6);
  });

  return () => {
    master.gain.setTargetAtTime(0, ctx.currentTime, 0.12);
    setTimeout(() => ctx.close(), 500);
  };
};
